module.exports = __webpack_public_path__ + "img/pole labs.a7a208c6.svg";